import { useState, useEffect, useCallback } from 'react';

export const useSpeechSynthesis = () => {
  const [voices, setVoices] = useState<SpeechSynthesisVoice[]>([]);
  const [selectedVoice, setSelectedVoice] = useState<SpeechSynthesisVoice | null>(null);

  // Carrega as vozes disponíveis
  useEffect(() => {
    const loadVoices = () => {
      const availableVoices = window.speechSynthesis.getVoices();
      setVoices(availableVoices);

      // Tenta recuperar a voz preferida do localStorage
      const savedVoiceName = localStorage.getItem('preferredVoice');
      
      if (savedVoiceName) {
        const savedVoice = availableVoices.find(v => v.name === savedVoiceName);
        if (savedVoice) {
          setSelectedVoice(savedVoice);
          console.log('Voz carregada do localStorage:', savedVoice.name);
          return;
        }
      }

      // Se não encontrou voz salva, procura por prioridade
      const preferredVoice = availableVoices.find(
        voice => 
          voice.name.toLowerCase().includes('google') && 
          voice.lang.toLowerCase().includes('pt-br')
      ) || availableVoices.find(
        voice => 
          voice.name.toLowerCase().includes('maria') && 
          voice.lang.toLowerCase().includes('pt')
      ) || availableVoices.find(
        voice => voice.lang.toLowerCase().includes('pt-br')
      );

      if (preferredVoice) {
        setSelectedVoice(preferredVoice);
        console.log('Voz selecionada:', preferredVoice.name);
      }
    };

    loadVoices();

    // Importante: algumas versões do Chrome precisam deste evento
    if (typeof window !== 'undefined' && window.speechSynthesis) {
      window.speechSynthesis.onvoiceschanged = loadVoices;
    }

    return () => {
      if (typeof window !== 'undefined' && window.speechSynthesis) {
        window.speechSynthesis.onvoiceschanged = null;
      }
    };
  }, []);

  const speak = useCallback((text: string) => {
  if (!text.trim() || !selectedVoice) return;

  // Cancela qualquer fala em andamento de forma segura
  try {
    window.speechSynthesis.cancel();
  } catch (e) {
    console.error('Erro ao cancelar síntese:', e);
  }

  try {
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.voice = selectedVoice;
    utterance.lang = selectedVoice.lang;
    utterance.rate = 1;
    utterance.pitch = 1;

    utterance.onend = () => {
      console.log('Síntese finalizada');
    };

    utterance.onerror = (e) => {
      console.error('Erro na síntese:', e);
    };

    console.log('Falando com a voz:', selectedVoice.name);
    window.speechSynthesis.speak(utterance);
  } catch (e) {
    console.error('Erro ao iniciar síntese:', e);
  }
}, [selectedVoice]);

  return {
    speak,
    voices,
    selectedVoice,
    setSelectedVoice
  };
};